import { useRequiredParams } from '@pba/react-router';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { VideoControlProvider, VideoDetailContent, VideoDetailHeader, VideoDetailLayout } from 'features/videos';
import { useGetPathToEntityDetail } from '../../hooks';
import { usePathToVideoList } from '../hooks';

const PageVideoDetail = () => {
  const { videoId } = useRequiredParams<{ videoId: string }>();
  const getPathToEntityDetail = useGetPathToEntityDetail();

  const getPathToVideoList = usePathToVideoList();
  const navigate = useNavigate();

  const navigateToVideoList = useCallback(async () => {
    await navigate(getPathToVideoList());
  }, [getPathToVideoList, navigate]);

  return (
    <VideoControlProvider>
      <VideoDetailLayout
        header={({ trailerData, videoContentObject }) => (
          <VideoDetailHeader
            navigateToVideoList={navigateToVideoList}
            trailerData={trailerData}
            videoContentObject={videoContentObject}
          />
        )}
        id={videoId}
      >
        {({ fullData, trailerData, videoContentObject }) => (
          <VideoDetailContent
            fullData={fullData}
            getPathToEntityDetail={getPathToEntityDetail}
            trailerData={trailerData}
            videoContentObject={videoContentObject}
          />
        )}
      </VideoDetailLayout>
    </VideoControlProvider>
  );
};

export default PageVideoDetail;
